import mergeVariables from '../../../fe-brary-internals/merge-variables';
var neutrals = () => ({
  colour: {
    white: '#fff',
    black: '#000',
    neutral50: '#fafbfc',
    neutral100: '#f2f5f7',
    neutral200: '#e6e9ed',
    neutral300: '#d0d3d9',
    neutral400: '#a9afba',
    neutral500: '#7e8594',
    neutral600: '#515b6e',
    neutral700: '#3c475b',
    neutral800: '#1e293d',
    neutral900: '#000'
  }
});
var neutralTexts = context => ({
  colour: {
    neutral50Text: context.colour.neutral700,
    neutral100Text: context.colour.neutral700,
    neutral200Text: context.colour.neutral700,
    neutral300Text: context.colour.neutral700,
    neutral400Text: context.colour.neutral700,
    neutral500Text: context.colour.white,
    neutral600Text: context.colour.white,
    neutral700Text: context.colour.white,
    neutral800Text: context.colour.white,
    neutral900Text: context.colour.white
  }
});
var palette = context => ({
  colour: {
    primaryLight: context.colour.priceFinderNavy400,
    primary: context.colour.priceFinderNavy500,
    primaryDark: context.colour.priceFinderNavy600,
    primaryLightText: context.colour.white,
    primaryText: context.colour.white,
    primaryDarkText: context.colour.white,
    secondaryLight: context.colour.priceFinderGreen400,
    secondary: context.colour.priceFinderGreen500,
    secondaryDark: context.colour.priceFinderGreen600,
    secondaryLightText: context.colour.white,
    secondaryText: context.colour.white,
    secondaryDarkText: context.colour.white,
    accentLight: context.colour.priceFinderLobster100,
    accent: context.colour.priceFinderLobster500,
    accentDark: context.colour.priceFinderLobster600,
    accentLightText: context.colour.neutral800,
    accentText: context.colour.white,
    accentDarkText: context.colour.white
  }
});
var namedColours = context => ({
  colour: {
    brandGreen25: context.colour.priceFinderGreen25,
    brandGreenLight: context.colour.priceFinderGreen50,
    brandGreen: context.colour.priceFinderGreen500,
    brandGreenDark: context.colour.priceFinderGreen600,
    brandOrangeLight: context.colour.priceFinderLobster100,
    brandOrange: context.colour.priceFinderLobster500,
    brandOrangeDark: context.colour.priceFinderLobster600,
    brandYellowLight: context.colour.priceFinderCanary100,
    brandYellow: context.colour.priceFinderCanary500,
    brandYellowDark: '#ffa200',
    brandAquaLight: context.colour.priceFinderTurquoise100,
    brandAqua: context.colour.priceFinderTurquoise500,
    brandPurple: context.colour.priceFinderGrimace500,
    brandBlue: context.colour.priceFinderBlurple500,
    brandBlueDark: context.colour.priceFinderNavy500
  }
});
export default (context => mergeVariables(neutrals, neutralTexts, palette, namedColours)(context));